
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...rest]",
      function () {
        return require("private-next-pages/[...rest].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...rest]"])
      });
    }
  